import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import "./i18n";
import "./index.css";

let persistor = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store} dir={document.body.dir === "rtl" ? "rtl" : "ltr"}>
    <PersistGate persistor={persistor}>
        <App />
    </PersistGate>
  </Provider>
);

reportWebVitals();
